import Layout from 'features/shared/Layout';

import SolutionsIndex from 'features/solutions/Index';

export default function Index() {
  return (
    <Layout
      description="Browse through the other people's challenge solutions. Give them support and feedback and learn from how they approached the challenge."
      image="https://res.cloudinary.com/dz209s6jk/image/upload/v1585172856/Meta/meta-homepage.png"
      url="https://www.frontendmentor.io/solutions"
    >
      <SolutionsIndex />
    </Layout>
  );
}

export async function getStaticProps() {
  return { props: {} };
}
